export default __webpack_public_path__ + "static/media/news39.95472f0c.jpg";